import { IRequestContext } from '@msdyn365-commerce/core-internal';
import { useEffect, useRef } from 'react';
import { CategoryHierarchy } from '@msdyn365-commerce/commerce-entities';
import { CategoryProductsResponse } from '../../relewise/types/mapped';
import { ITelemetry } from '@msdyn365-commerce/telemetry-internal';
import { useDatalayerService } from './useDatalayerService';

interface UsePlpDatalayerParams {
    request: IRequestContext;
    telemetry: ITelemetry;
    activeProducts: CategoryProductsResponse | undefined;
    category: CategoryHierarchy | undefined;
    isSearchMode: boolean;
    currentIndex: number;
}

export const usePlpDatalayer = ({
    request,
    telemetry,
    activeProducts,
    category,
    isSearchMode,
    currentIndex
}: UsePlpDatalayerParams): void => {
    const datalayerService = useDatalayerService({ request, telemetry });
    const hasFiredRef = useRef(false);

    useEffect(() => {
        if (hasFiredRef.current || !activeProducts) {
            return;
        }
        hasFiredRef.current = true;
        const plpProducts = activeProducts.productList.map((p, i) => ({
            item_id: p.variant?.concatenatedId ?? '',
            item_name: p.variant?.displayName,
            price: p.variant?.finalPrice,
            item_brand: p.variant?.brand,
            index: currentIndex + i
        }));

        datalayerService.pushViewItemList(plpProducts, isSearchMode ? undefined : category);
        if (isSearchMode) {
            datalayerService.pushSearch();
        }
    }, [activeProducts, datalayerService, category, isSearchMode, currentIndex]);
};
